import { render, staticRenderFns } from "./drafts.vue?vue&type=template&id=7dd322d6"
import script from "./drafts.vue?vue&type=script&lang=js"
export * from "./drafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports